/**
 * Função que monitora as alterações nas variantes e atualiza o botão flutuante
 */
function configurarBotaoFlutanteCompra() {
  // Função para atualizar o botão flutuante com base no botão principal
  function atualizarBotaoFlutuante() {
    // Localiza os botões
    const botaoCompraPrincipal = document.querySelector('.product-selector .bye-product');
    const containerFlutuante = document.querySelector('.floating-buy-button');
    
    if (!botaoCompraPrincipal || !containerFlutuante) {
      console.log('Um ou mais elementos não foram encontrados.');
      return;
    }
    
    // Remove o botão flutuante antigo se existir
    const botaoFlutuanteAntigo = containerFlutuante.querySelector('.bye-product');
    if (botaoFlutuanteAntigo) {
      botaoFlutuanteAntigo.remove();
    }
    
    // Clona o botão principal
    const botaoClonado = botaoCompraPrincipal.cloneNode(true);
    
    // Adiciona um identificador único para o botão clonado (opcional)
    botaoClonado.setAttribute('data-cloned', 'true');
    
    // Adiciona o botão clonado ao container flutuante
    containerFlutuante.appendChild(botaoClonado);
    
    // Adiciona o evento de clique no botão clonado para acionar o botão principal
    botaoClonado.addEventListener('click', function(evento) {
      // Apenas previne o comportamento padrão se o botão não estiver desabilitado
      if (!botaoCompraPrincipal.disabled) {
        evento.preventDefault();
        botaoCompraPrincipal.click();
        console.log('Clique no botão principal acionado pelo botão clonado');
      }
    });
    
    console.log('Botão flutuante atualizado com sucesso.');
  }
  
  // Monitora alterações nos seletores de opções (variantes)
  const seletoresOpcoes = document.querySelectorAll('.opt-btn');
  if (seletoresOpcoes.length > 0) {
    seletoresOpcoes.forEach(function(seletor) {
      seletor.addEventListener('change', function() {
        // Adiciona um pequeno atraso para garantir que a interface tenha sido atualizada
        setTimeout(atualizarBotaoFlutuante, 200);
      });
    });
  }
  
  // Monitora cliques nos labels de opções que ativam os radio buttons
  const labelsOpcoes = document.querySelectorAll('.opt-label');
  if (labelsOpcoes.length > 0) {
    labelsOpcoes.forEach(function(label) {
      label.addEventListener('click', function() {
        // Adiciona um pequeno atraso para garantir que a interface tenha sido atualizada
        setTimeout(atualizarBotaoFlutuante, 200);
      });
    });
  }
  
  // Inicializa o botão flutuante
  atualizarBotaoFlutuante();
  
  // Adiciona um observador de mutações para garantir que as alterações na interface sejam capturadas
  const observador = new MutationObserver(function(mutacoes) {
    // Verifica se alguma das mutações afeta os seletores de variantes ou o botão principal
    for (const mutacao of mutacoes) {
      if (mutacao.target.closest('.option-selectors') || 
          mutacao.target.closest('.product-selector')) {
        setTimeout(atualizarBotaoFlutuante, 200);
        break;
      }
    }
  });
  
  // Observa as mudanças no container do produto
  const containerProduto = document.querySelector('.product-form');
  if (containerProduto) {
    observador.observe(containerProduto, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }
}

// Executa a configuração quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function() {
  configurarBotaoFlutanteCompra();
});